import React from 'react';

import Grid from 'components/Grid';
import { ColumnDefinition, FilterType } from 'components/Grid/types';

import InitialAvatar from 'components/Avatar/InitialAvatar';

import { MemberRow, PreviewStatus, RuleRequest } from 'utils/api/modules/memberGroups';

import { MemberNameCell } from './styles';

export interface PreviewMemberTableProps {
  rule: RuleRequest;
  status: PreviewStatus;
  groupUuid?: string;
  temporaryFilters?: FilterType[];
}

const columns = [
  {
    field: 'name',
    headerName: 'Name',
    flex: 1.4,
    minWidth: 220,
    renderCell: ({ row }: { row: MemberRow }) => (
      <MemberNameCell>
        <InitialAvatar name={row.name} size="small" />
        <span>{row.name}</span>
      </MemberNameCell>
    ),
  },
  {
    field: 'jobTitle',
    headerName: 'Job title',
    flex: 1,
    minWidth: 160,
    sortingField: 'job_title',
    renderCell: ({ row }: { row: MemberRow }) => row.jobTitle || '—',
  },
  {
    field: 'department',
    headerName: 'Department',
    flex: 1,
    minWidth: 150,
    sortable: false,
    renderCell: ({ row }: { row: MemberRow }) => row.department?.name || '—',
  },
  {
    field: 'site',
    headerName: 'Site',
    flex: 1,
    minWidth: 150,
    sortable: false,
    renderCell: ({ row }: { row: MemberRow }) => row.site?.name || '—',
  },
] as unknown as ColumnDefinition[];

const PreviewMemberTable: React.FunctionComponent<PreviewMemberTableProps> = ({
  rule,
  status,
  groupUuid,
  temporaryFilters,
}) => {
  const body = React.useMemo(() => (groupUuid ? { rule, group: groupUuid } : { rule }), [rule, groupUuid]);

  return (
    <Grid
      basicColumns={columns}
      dataURL={`member-groups/preview/members/?status=${status}`}
      method="POST"
      body={body}
      sortBy={{ field: 'name', sort: 'asc' }}
      temporaryFilters={temporaryFilters}
      showQuickFilter={false}
      showHeader={false}
      customNoRowsText="No users to show"
      disableColumnSelector
      disableColumnFilter
      disableExport
      disableSavePreferences
    />
  );
};

export default PreviewMemberTable;
